<template>
  <div>
    <div class="container position-sticky z-index-sticky top-0">
    <div class="row">
      <div class="col-12">
        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg blur blur-rounded top-0 z-index-3 shadow position-absolute my-3 py-2 start-0 end-0 mx-4">
          <div class="container-fluid pe-0">
            <a class="navbar-brand font-weight-bolder ms-lg-0 ms-3 " href="login">
              <img src="../../core_assets/img/sifvflogo.png" class="navbar-brand-img h-100" alt="main_logo">
            </a>
            <button class="navbar-toggler shadow-none ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon mt-2">
                <span class="navbar-toggler-bar bar1"></span>
                <span class="navbar-toggler-bar bar2"></span>
                <span class="navbar-toggler-bar bar3"></span>
              </span>
            </button>
            <div class="collapse navbar-collapse" id="navigation">
              <ul class="navbar-nav mx-auto ms-xl-auto me-xl-7">
                <li class="nav-item">
                  <a class="nav-link me-2" href="login">
                    <i class="fas fa-key opacity-6 text-dark me-1"></i>
                    Inicio
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link me-2" href="login">
                    <i class="fas fa-key opacity-6 text-dark me-1"></i>
                    Acerca Barquisimeto Golf Club
                  </a>
                </li>
                
               
              </ul>
              <!--  -->
              <ul class="navbar-nav d-lg-block d-none">
               
              </ul>
            </div>
          </div>
        </nav>
        <!-- End Navbar -->
      </div>
    </div>
  </div>
   <main class="main-content  mt-0">
    <section>
      <div class="page-header mt-0 min-vh-75" style="max-height: auto !important;">
        <div class="container">
          <div class="row">
            <div class="col-md-12 d-flex flex-column mx-auto">
              <div class="card card-plain mt-0">
                <div class="card-header pb-0 text-left bg-transparent">
                  <h3 class="font-weight-bolder text-primary text-center">Bienvenido</h3>
                  <p class="mb-0 text-center">Estamos en construcción de esta sección</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-5 d-flex flex-column mx-auto ">
              <div class="card card-plain">
                <div class="card-header pb-0 text-left bg-transparent">
                  <h3 class="font-weight-bolder text-primary text-center">En construcción..</h3>
                  <p class="mb-0 text-center">En construcción..</p>
                </div>
              </div>
            </div>
            <div class="col-md-7 d-flex flex-column mx-auto ">
              <div class="position-absolute top-2 d-md-block d-none me-n8">
                <img src="../../core_assets/img/grillo-emiliano-golf.jpg" class="img-fluid navbar-brand-img" alt="main_logo" style="height: 480px; width: 80%;">
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
 <layout-footer></layout-footer>
</div>
</template>

<script>
import Swal from "sweetalert2";
import LayoutFooter from "./Layouts/Footer"
import { mapActions } from 'vuex'
export default {
  name: 'about',
  components:{
    LayoutFooter
  },
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions(["about"]),

    OnSubmit() {
      if (this.model.email == "" || this.model.password == "") {
        Swal.fire({
          title: 'Atención',
          text: 'Complete todos los campos para continuar',
          icon: 'warning',
          customClass: {
            confirmButton: "btn-info"
          }
        })
      } else {
        Swal.showLoading()
        this.login(this.model)
          .then((response => {
            if (response.code == 200) {
              this.$router.push('/overview')
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                icon: "success",
                title: "¡Bienvenido!",
                customClass: {
                  confirmButton: "btn-info"
                }
              });
            }
            else if (response.code == 403) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Este usuario no puede acceder al panel administrativo",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            }
            else if (response.code == 402) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Revisa tus credenciales e intenta nuevamente",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            } else {
              Swal.fire({
                title: "Ocurrió un error",
                text: "Revisa tus credenciales e intenta nuevamente",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            }
          }))
          .catch((error => {
            console.log(error)
            if (error.code == 402) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Revisa tus credenciales e intenta nuevamente",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            }
            else if (error.code == 403) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "Este usuario no puede acceder al panel administrativo",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            }
            else if (error.code == 404) {
              Swal.fire({
                title: "Usuario no encontrado",
                text: "No se encuentra un usuario activo con estos datos",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            }
            else {
              Swal.fire({
                title: "Ocurrió un error",
                text: "Revisa tus credenciales, e intenta nuevamente",
                icon: "warning",
                customClass: {
                  confirmButton: "btn-info"
                }
              })
            }

          }))
      }
    }
  }
}
</script>
<style>
.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;

  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  /* .gradient-custom-2 {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
  } */
}
</style>